module.exports = __webpack_public_path__ + "img/lab5.c0f47df2.jpeg";